import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';

export interface ISubscriptionApi {
  getSubscription(subscriptionNumber: string): Promise<APIResponse<any>>;
  initializeJourney(): Promise<APIResponse<any>>;
  initializeJourneyWithShortCode(shortOfferCode: string): Promise<APIResponse<any>>;
  getSecureSubscription(secureToken: string, subscriptionNumber: string): Promise<APIResponse<any>>;
  createPendingSubscription(prospection: {}): Promise<APIResponse<any>>;
  createPendingSubscriptionWithRecaptcha(prospection: {}, reCaptchaValue: string): Promise<APIResponse<any>>;
  validateSubscriptionAction(subscriptionNumber: string): Promise<APIResponse<any>>;
  getSubscriptionDocumentsSigned(subscriptionNumber: string): Promise<APIResponse<any>>;
  requestSigningTransactionUrl(subscriptionNumber: string): Promise<APIResponse<any>>;
  requestSubscriptionSignStatus(subscriptionNumber: string): Promise<APIResponse<any>>;
  requestSigningDocuments(subscriptionNumber: string, signRequest: any): Promise<APIResponse<any>>;
}

export class SubscriptionApi implements ISubscriptionApi {
  async getSubscription(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get('/journey/session-init/' + subscriptionNumber));
  }

  async initializeJourney(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('/journey/session-init'));
  }

  async initializeJourneyWithShortCode(shortOfferCode: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get('/journey/session-init/short-code/' + shortOfferCode));
  }

  async getSecureSubscription(secureToken: string, subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.post('/journey/session-secure-init/' + subscriptionNumber, secureToken));
  }

  async createPendingSubscription(prospection: {}): Promise<APIResponse<any>> {
    return returnAxios(axios.post('journey/prospection-transmit', prospection));
  }
  async createPendingSubscriptionWithRecaptcha(prospection: {}, reCaptchaValue: string): Promise<APIResponse<any>> {
    return returnAxios(axios.post('journey/prospection-transmit?reCaptchaValue=' + reCaptchaValue, prospection));
  }

  async validateSubscriptionAction(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get('journey/validation-transmit/' + subscriptionNumber));
  }

  async getSubscriptionDocumentsSigned(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get('journey/subscription-documents-signed/' + subscriptionNumber));
  }

  async requestSigningTransactionUrl(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get(`journey/documents-sign/${subscriptionNumber}`, {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }

  async requestSigningDocuments(subscriptionNumber: string, token : string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.post(`journey/subscriptions/${subscriptionNumber}/sign-documents`, null, {
        headers: {
          'Accept-Language': 'fr-FR',
          'Content-Type': 'application/json',
          'X-Subscription-Token': token
        }
      })
    );
  }

  async requestSubscriptionSignStatus(subscriptionNumber: string): Promise<APIResponse<any>> {
    return returnAxios(axios.get(`journey/subscription-sign/${subscriptionNumber}`));
  }
}
